var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlutenFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    stroke: "#EF9500",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2406 18.3337C13.5946 15.5052 16.0371 13.3151 19 13.3151C19 16.4633 16.4256 19.0169 13.2406 19.0413V23.2292L12.7596 23.2299V19.0413C9.57463 19.0169 7 16.4633 7 13.3151C9.96309 13.3151 12.4057 15.5054 12.7596 18.3342V14.1455C9.57463 14.1209 7 11.5673 7 8.41951C9.96309 8.41951 12.4057 10.6099 12.7596 13.4384V11.846C10.7372 9.59682 10.8167 6.15407 13.0001 4C15.1836 6.15407 15.2631 9.59682 13.2406 11.8458V13.4379C13.5946 10.6094 16.0371 8.41951 19 8.41951C19 11.5673 16.4256 14.1209 13.2406 14.1455V18.3337Z",
    fill: "#EF9500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlutenFree);
export default __webpack_public_path__ + "static/media/icon-gluten-free.3f36f3b2f2ba02a88367ccbb8762323c.svg";
export { ForwardRef as ReactComponent };